import { AudioRecorder, useAudioRecorder } from '@/components/voice/AudioVoiceRecorder';
import useGeneratorStore from '@/state/generator-store';
import React from 'react';
import { useModel } from '../model';

interface R3AudioRecorderProps {
  disabled: boolean;
}

const R3AudioRecorder: React.FC<R3AudioRecorderProps> = ({ disabled }) => {
  const recorderControls = useAudioRecorder();

  const { setRecordingStatus, setRecordingTime, isCountdown, setIsCountdown, r3ImageStatus, generatorType } = useGeneratorStore();

  const { handleRecordingComplete } = useModel();

  return (
    <div className="h-full w-full mt-1">
      <AudioRecorder
        showVisualizer={true}
        recorderControls={recorderControls}
        onRecordingComplete={handleRecordingComplete}
        setRecordingStatus={setRecordingStatus}
        setRecordingTime={setRecordingTime}
        isCountdown={isCountdown}
        setIsCountdown={setIsCountdown}
        disabled={disabled}
        status={r3ImageStatus}
        generatorType={generatorType}
      />
    </div>
  );
};

export default R3AudioRecorder;
